import React from "react";
import StoreBanner from "../../../components/StoreBanner";
import RoundedRectangle from "../../../components/RoundedRectangle";

const ProfileLeftSide: React.FC = () => (
    <div className="hidden xl:block [@media(pointer:coarse)]:hidden">
        <RoundedRectangle
            className="bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark mb-4"
            hasBorder
        >
            <StoreBanner border={false} />
        </RoundedRectangle>
    </div>
);

export default ProfileLeftSide;
